var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main1"},[_c('invite-team',{attrs:{"type":_vm.type,"codeObj":_vm.codeInfo},on:{"createCode":_vm.makeInviteCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }